import React from 'react';
import { useRecoilState } from 'recoil';
import { Box, Heading, FormControl, FormLabel, Select, Button, Tooltip, Icon, HStack } from '@chakra-ui/react';
import { InfoIcon } from '@chakra-ui/icons';
import { formDataState } from '../../state/calculatorState';
import { circulationValues, pressRegimeValues } from '../../utils/complexityCalculator';

const TOOLTIPS = {
  circulatingTemp: 'Expected circulating temperature during drilling operations',
  pressureRegime: 'Formation pressure regime classification (Normal, Abnormal, Subnormal)',
  ubompd: 'Underbalanced Operations or Managed Pressure Drilling required'
};

const LabelWithInfo = ({ children, tooltip }) => (
  <HStack spacing={1}>
    <span>{children}</span>
    <Tooltip label={tooltip} placement="top" hasArrow>
      <span><Icon as={InfoIcon} boxSize={3} color="gray.400" cursor="help" /></span>
    </Tooltip>
  </HStack>
);

export const ConstructionSection = ({ compact }) => {
  const [formData, setFormData] = useRecoilState(formDataState);

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleBoolToggle = (field) => {
    setFormData(prev => ({ ...prev, [field]: !prev[field] }));
  };

  return (
    <Box bg="white" p={compact ? 0 : 5} borderRadius={compact ? 0 : 'lg'} boxShadow={compact ? 'none' : 'sm'}>
      {!compact && <Heading size="md" mb={4}>Construction</Heading>}

      <FormControl mb={3}>
        <FormLabel fontSize="sm" fontWeight="semibold">
          <LabelWithInfo tooltip={TOOLTIPS.circulatingTemp}>Circulating Temp</LabelWithInfo>
        </FormLabel>
        <Select size="sm" value={formData.circulatingTemp} onChange={(e) => handleChange('circulatingTemp', e.target.value)}>
          <option value="" disabled>Select...</option>
          {Object.entries(circulationValues).map(([key, { txt }]) => (
            <option key={key} value={key}>{txt}</option>
          ))}
        </Select>
      </FormControl>

      <FormControl mb={3}>
        <FormLabel fontSize="sm" fontWeight="semibold">
          <LabelWithInfo tooltip={TOOLTIPS.pressureRegime}>Pressure Regime</LabelWithInfo>
        </FormLabel>
        <Select size="sm" value={formData.pressureRegime} onChange={(e) => handleChange('pressureRegime', e.target.value)}>
          <option value="" disabled>Select...</option>
          {Object.entries(pressRegimeValues).map(([key, { txt }]) => (
            <option key={key} value={key}>{txt}</option>
          ))}
        </Select>
      </FormControl>

      <Tooltip label={TOOLTIPS.ubompd} placement="top" hasArrow>
        <Button
          size="xs"
          role="switch"
          aria-checked={formData.ubompd}
          variant={formData.ubompd ? 'solid' : 'outline'}
          colorScheme={formData.ubompd ? 'blue' : 'gray'}
          onClick={() => handleBoolToggle('ubompd')}
        >
          UBO & MPD
        </Button>
      </Tooltip>
    </Box>
  );
};

export default ConstructionSection;
